import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
           <div>
  <footer className="main-footer">
    <strong>Copyright © 2025 <a href="">SistemApp</a>. </strong>
     Todos os Direitos Resevados. Whats: (99) 984136843
    <div className="float-right d-none d-sm-inline-block">
      <b>Version</b> 1.0.0
    </div>
  </footer>
</div>

        )
    }
}
